function normalizeBaseUrl(rawValue) {
  const value = (rawValue || '').trim();
  if (!value) return '';

  const withoutTrailingSlash = value.replace(/\/+$/, '');
  if (!/^https?:\/\//i.test(withoutTrailingSlash)) {
    return withoutTrailingSlash;
  }

  return withoutTrailingSlash.replace(/\/api\/?$/i, '');
}

function getCurrentProtocol() {
  if (typeof window !== 'undefined' && window.location?.protocol) {
    return window.location.protocol;
  }
  return 'http:';
}

export function getBackendOrigin() {
  return normalizeBaseUrl(process.env.REACT_APP_API_URL);
}

export function getApiBaseUrl() {
  const origin = getBackendOrigin();
  if (!origin) return '/api';
  return origin.endsWith('/api') ? origin : `${origin}/api`;
}

export function getBackendUrl(path = '') {
  const origin = getBackendOrigin();
  if (!origin) return path || '';
  const normalizedPath = path ? (path.startsWith('/') ? path : `/${path}`) : '';
  return `${origin}${normalizedPath}`;
}

export function getApiUrl(path = '') {
  const baseUrl = getApiBaseUrl();
  if (!baseUrl) return path || '';
  const normalizedPath = path ? (path.startsWith('/') ? path : `/${path}`) : '';
  return `${baseUrl}${normalizedPath}`;
}

export function getSecureAssetUrl(url, currentProtocol = getCurrentProtocol()) {
  if (!url) return '';

  const trimmedUrl = String(url).trim();
  if (!trimmedUrl) return '';

  if (/^https?:\/\//i.test(trimmedUrl)) {
    if (currentProtocol === 'https:') {
      return trimmedUrl.replace(/^http:/i, 'https:');
    }
    return trimmedUrl;
  }

  if (trimmedUrl.startsWith('//')) {
    return currentProtocol === 'https:' ? `https:${trimmedUrl}` : `http:${trimmedUrl}`;
  }

  if (trimmedUrl.startsWith('/')) {
    const backendOrigin = getBackendOrigin();
    if (!backendOrigin) return trimmedUrl;
    const normalizedOrigin = backendOrigin.replace(/^http:/i, currentProtocol === 'https:' ? 'https:' : 'http:');
    return `${normalizedOrigin}${trimmedUrl}`;
  }

  return trimmedUrl;
}
